import { transformRecordToOption } from '@/utils'

export const enableStatusRecord: Record<string, string> = {
  1: '允许',
  2: '禁用',
}

export const userGenderRecord: Record<string, string> = {
  0: '男',
  1: '女',
}
export const userGenderOptions = transformRecordToOption(userGenderRecord)
